export enum LoanStatusInOldSystem {
  OPEN_LOAN = 'OPEN_LOAN',
  NO_LOANS = 'NO_LOANS',
  HAS_CLOSED_LOAN = 'HAS_CLOSED_LOAN'
}
